import type {
  LeadTimeStrategyBuilder,
  LeadTimeStrategyResultBuilder,
} from '@calculations/lead-time/builders';
import type { Weeks } from '@calculations/lead-time/time';

export const RAFFixedMarket = 'RAFFixedMarket' as const;

export type RAFFixedMarket = typeof RAFFixedMarket;

export type RAFFixedMarketLeadTimeStrategy = LeadTimeStrategyBuilder<
  RAFFixedMarket,
  {
    default: Weeks;
    nasParts: Weeks;
  }
>;

export type RAFFixedMarketLeadTimeStrategyResult =
  LeadTimeStrategyResultBuilder<RAFFixedMarket>;
